import { FC } from 'react';
import styled from 'styled-components';

interface AccountStatusProps {
	locked: boolean;
	hasPendingInvitation: boolean | null;
}

const AccountStatusText = styled.span<{
	$variant: 'active' | 'reserved' | 'locked' | 'lockedAndReserved';
}>`
	color: ${({ theme, $variant }) => {
		switch ($variant) {
			case 'active':
				return theme.colors.textSuccess;
			case 'reserved':
				return theme.colors.textWarning;
			case 'locked':
			case 'lockedAndReserved':
				return theme.colors.textError;
		}
	}};
`;

export const AccountStatus: FC<AccountStatusProps> = ({
	locked,
	hasPendingInvitation,
}) => {
	if (locked && hasPendingInvitation) {
		return (
			<AccountStatusText $variant="lockedAndReserved">
				Reserved
			</AccountStatusText>
		);
	}
	if (hasPendingInvitation) {
		return (
			<AccountStatusText $variant="reserved">Reserved</AccountStatusText>
		);
	}

	if (locked) {
		return <AccountStatusText $variant="locked">Locked</AccountStatusText>;
	}

	return <AccountStatusText $variant="active">Active</AccountStatusText>;
};
